import { articles, categories, page as pageQuery } from "@data/queries";
import { Container, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import sanity from '@utils/sanity';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { ArticleProps } from 'src/@types/article';
import { CategoryProps } from 'src/@types/category';
import { PageProps } from 'src/@types/page';
import Routes from "src/routes";
import BlogFeaturedPosts from 'src/sections/blog/BlogFeaturedPosts';
import BlogPostList from 'src/sections/blog/BlogPostList';
import { Page } from '../../src/components';
import { HEADER_DESKTOP_HEIGHT, HEADER_MOBILE_HEIGHT } from '../../src/config';
import Layout from '../../src/layouts';
import { BlogSidebar } from '../../src/sections/blog';
import { Newsletter } from '../../src/sections/newsletter';


// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: HEADER_MOBILE_HEIGHT,
  [theme.breakpoints.up('md')]: {
    paddingTop: HEADER_DESKTOP_HEIGHT,
  },
}));

// ----------------------------------------------------------------------

type Props = {
  data: {
    articles: ArticleProps[];
    categories: CategoryProps[];
  }
  page: PageProps;
};

export default function BlogPage({ data, page }: Props) {
  const router = useRouter();

  return (
    <Page seo={page.seo}>
      <RootStyle>

        <BlogFeaturedPosts article={data.articles[0]} />

        <Container
          sx={{
            mt: { xs: 4, md: 10 },
            mb: { xs: 4, md: 10 },
          }}
        >
          <Grid container spacing={{ xs: 4, md: 8 }}>
            <Grid item xs={12} md={8}>
              <BlogPostList
                articles={data.articles.filter(
                  (article) =>
                    article.categories.some((e) => e.name.toLowerCase() == router.query.category) ||
                    router.query.category == undefined
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <BlogSidebar
                categories={data.categories}
                recentPosts={{
                  list: data.articles.slice(-4),
                  path: '/aktuelt',
                }}
                advertisement={{
                  title: 'Ny Elbillader?',
                  description: 'Verdens smarteste elbillader, ferdig montert',
                  imageUrl:
                    'image-a0be3eac397b7d6809ea422bbcdd51a058a93276-1440x960-jpg',
                  path: '/kampanjer/elbillader/',
                }}
              />
            </Grid>
          </Grid>
        </Container>
        <Newsletter />
      </RootStyle>
    </Page>
  );
}

// ----------------------------------------------------------------------

BlogPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

// ----------------------------------------------------------------------

export async function getStaticProps() {
  const query = `
    {
      "articles": ${articles(50)},
      "categories": ${categories}
    }
  `

  const data = await sanity.fetch(query);
  const page = await sanity.fetch(pageQuery, { slug: Routes.blog });
  return {
    props: { page, data }, // will be passed to the page component as props
  };
}
